import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MobMaskDirective } from "./mob-mask.directive";



@NgModule({
  declarations: [MobMaskDirective],
  imports: [
    CommonModule
  ],
  exports: [MobMaskDirective]
})
export class MobMaskModule { }
